import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { products } from "../data/productsData";
import { FaChevronRight, FaPhoneAlt, FaWhatsapp } from "react-icons/fa";

const productIcons = ["🧱", "🪟", "🚿", "💎", "🪞", "🔩", "🏗️", "🏠", "💡", "🏢"];

export default function ProductList() {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        document.title = "Product Catalogue | S.N.S. Glass House – Glass Works in South Delhi";
    }, []);

    return (
        <div className="product-list-page">
            {/* ── HERO ── */}
            <section className="pl-hero">
                <div className="pl-hero__overlay" />
                <div className="pl-hero__content">
                    <p className="pl-hero__eyebrow">S.N.S. Glass House</p>
                    <h1 className="pl-hero__title">Product Catalogue</h1>
                    <p className="pl-hero__subtitle">
                        Premium glass solutions in Chhatarpur, Vasant Kunj & South Delhi
                    </p>
                </div>
            </section>

            {/* ── BREADCRUMB ── */}
            <nav className="pd-breadcrumb" aria-label="breadcrumb">
                <Link to="/">Home</Link>
                <FaChevronRight />
                <span>Products</span>
            </nav>

            {/* ── PRODUCT GRID ── */}
            <div className="pl-container">
                <p className="pl-description">
                    Click on any product below to learn more about our services, pricing, applications and
                    frequently asked questions.
                </p>
                <div className="pl-grid">
                    {products.map((product, i) => (
                        <Link
                            key={product.id}
                            to={`/products/${product.slug}`}
                            className="pl-card"
                            id={`product-card-${product.id}`}
                        >
                            <div className="pl-card__icon">{productIcons[i]}</div>
                            <div className="pl-card__content">
                                <h2 className="pl-card__title">{product.navLabel}</h2>
                                <p className="pl-card__subtitle">{product.heroSubtitle}</p>
                            </div>
                            <div className="pl-card__arrow">
                                <FaChevronRight />
                            </div>
                        </Link>
                    ))}
                </div>

                {/* CTA */}
                <div className="pl-cta">
                    <h2>Need Help Choosing?</h2>
                    <p>Call or WhatsApp us for expert guidance and a free site visit.</p>
                    <div className="pl-cta__btns">
                        <a href="tel:9716043891" className="pd-cta-btn pd-cta-btn--primary" id="pl-call-btn">
                            <FaPhoneAlt /> 9716043891
                        </a>
                        <a href="https://wa.me/919716043891" target="_blank" rel="noreferrer" className="pd-cta-btn pd-cta-btn--whatsapp" id="pl-whatsapp-btn">
                            <FaWhatsapp /> WhatsApp
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
